import type { SlideFields } from "@/types/Slide";
import type { PhonicsDecodeSlideData } from "@ai-teach/types";
import { HiVolumeUp } from "react-icons/hi";
import { IoMicOutline } from "react-icons/io5";

interface PhonicsDecodeThumbnailProps {
  slide: SlideFields;
}

export function PhonicsDecodeThumbnail({ slide }: PhonicsDecodeThumbnailProps) {
  const data = slide.slideData as PhonicsDecodeSlideData | undefined;
  const phoneme = data?.phoneme;
  const hasAudio = !!data?.audio?.src;

  return (
    <div className="bg-purple-50 p-2 h-full flex flex-col gap-2 overflow-hidden">
      {/* Phoneme display */}
      <div className="flex-1 bg-white rounded-lg border border-purple-200 flex flex-col items-center justify-center gap-1 min-h-0">
        {phoneme ? (
          <span className="text-4xl font-black text-gray-800">{phoneme}</span>
        ) : (
          <span className="text-xs text-gray-400 italic">No phoneme set</span>
        )}
        <span className="text-[9px] text-purple-400 font-semibold uppercase tracking-wider">
          Say this!
        </span>
      </div>

      {/* Audio + mic indicators */}
      <div className="flex gap-2 shrink-0">
        <div
          className={`flex-1 flex items-center justify-center gap-1 py-1.5 rounded-lg border ${
            hasAudio ? "bg-blue-50 border-blue-200" : "bg-gray-50 border-gray-200"
          }`}
        >
          <HiVolumeUp className={hasAudio ? "text-blue-500 text-sm" : "text-gray-300 text-sm"} />
          <span
            className={`text-[9px] font-semibold ${hasAudio ? "text-blue-500" : "text-gray-400"}`}
          >
            Audio
          </span>
        </div>
        <div className="flex-1 flex items-center justify-center gap-1 py-1.5 rounded-lg border bg-purple-50 border-purple-200">
          <IoMicOutline className="text-purple-500 text-sm" />
          <span className="text-[9px] font-semibold text-purple-500">Record</span>
        </div>
      </div>
    </div>
  );
}
